import React from 'react'

type Props = {}

const SVGFileIcon = (props: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='50'
      height='66'
      viewBox='0 0 50 66'
      fill='none'
    >
      <path
        d='M29.0772 46.7479L24.9471 0H8C3.58172 0 0 3.58172 0 8V42.6829L29.0772 46.7479Z'
        fill='white'
      />
      <path
        d='M49.9998 42.6829V14.2276L39.8373 10.1626L35.7722 0H24.9471L25.0122 46.7479L49.9998 42.6829Z'
        fill='#E8E6E6'
      />
      <path
        d='M39.7722 14.2276C37.563 14.2276 35.7722 12.4368 35.7722 10.2276V0L49.9998 14.2276H39.7722Z'
        fill='white'
      />
      <path
        d='M50 42.6836H0V57.0413C0 61.4596 3.58172 65.0413 8 65.0413H42C46.4183 65.0413 50 61.4596 50 57.0413V42.6836Z'
        fill='#B3DA73'
      />
      <path
        d='M36 33C36 27.9649 32.617 23.7199 28 22.4141M14 33C14 28.0704 17.2427 23.8982 21.7114 22.5'
        stroke='#C9BDB8'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
      <rect
        x='22'
        y='19'
        width='6'
        height='6'
        stroke='#C9BDB8'
        strokeWidth='1.5'
      />
      <rect
        x='34'
        y='20'
        width='3'
        height='4'
        stroke='#C9BDB8'
        strokeWidth='1.5'
      />
      <rect
        x='13'
        y='20'
        width='3'
        height='4'
        stroke='#C9BDB8'
        strokeWidth='1.5'
      />
      <path
        d='M16 22L21.8655 22M34 22L28 22'
        stroke='#C9BDB8'
        strokeWidth='1.5'
      />
      <path
        d='M38.5398 51.1255C38.4602 50.849 38.3485 50.6047 38.2046 50.3926C38.0606 50.1767 37.8845 49.9949 37.6761 49.8471C37.4716 49.6956 37.2367 49.5801 36.9716 49.5005C36.7102 49.421 36.4205 49.3812 36.1023 49.3812C35.5076 49.3812 34.9849 49.5289 34.5341 49.8244C34.0871 50.1199 33.7386 50.5498 33.4886 51.1142C33.2386 51.6748 33.1136 52.3604 33.1136 53.171C33.1136 53.9816 33.2367 54.671 33.483 55.2392C33.7292 55.8074 34.0777 56.2411 34.5284 56.5403C34.9792 56.8358 35.5114 56.9835 36.125 56.9835C36.6818 56.9835 37.1572 56.885 37.5511 56.688C37.9489 56.4873 38.2519 56.2051 38.4602 55.8414C38.6724 55.4778 38.7784 55.0479 38.7784 54.5517L39.2784 54.6255H36.2784V52.7733H41.1477V54.2392C41.1477 55.2619 40.9318 56.1407 40.5 56.8755C40.0682 57.6066 39.4735 58.171 38.7159 58.5687C37.9583 58.9627 37.0909 59.1596 36.1136 59.1596C35.0227 59.1596 34.0644 58.9191 33.2386 58.438C32.4129 57.9532 31.7689 57.2657 31.3068 56.3755C30.8485 55.4816 30.6193 54.421 30.6193 53.1937C30.6193 52.2505 30.7557 51.4096 31.0284 50.671C31.3049 49.9286 31.6913 49.2998 32.1875 48.7846C32.6837 48.2695 33.2614 47.8774 33.9205 47.6085C34.5796 47.3395 35.2936 47.2051 36.0625 47.2051C36.7216 47.2051 37.3352 47.3017 37.9034 47.4949C38.4716 47.6842 38.9754 47.9532 39.4148 48.3017C39.858 48.6502 40.2197 49.0649 40.5 49.546C40.7803 50.0233 40.9602 50.5498 41.0398 51.1255H38.5398Z'
        fill='white'
      />
      <path
        d='M21.6136 47.3633L24.4261 56.2042H24.5341L27.3523 47.3633H30.0795L26.0682 58.9996H22.8977L18.8807 47.3633H21.6136Z'
        fill='white'
      />
      <path
        d='M15.3395 50.7108C15.294 50.2524 15.0989 49.8964 14.7543 49.6426C14.4096 49.3888 13.9418 49.2619 13.3508 49.2619C12.9493 49.2619 12.6103 49.3187 12.3338 49.4324C12.0573 49.5422 11.8452 49.6956 11.6974 49.8926C11.5535 50.0895 11.4815 50.313 11.4815 50.563C11.4739 50.7714 11.5175 50.9532 11.6122 51.1085C11.7107 51.2638 11.8452 51.3983 12.0156 51.5119C12.1861 51.6217 12.383 51.7183 12.6065 51.8017C12.83 51.8812 13.0686 51.9494 13.3224 52.0062L14.3679 52.2562C14.8755 52.3699 15.3414 52.5214 15.7656 52.7108C16.1899 52.9002 16.5573 53.1331 16.8679 53.4096C17.1785 53.6861 17.419 54.0119 17.5895 54.3869C17.7637 54.7619 17.8527 55.1918 17.8565 55.6767C17.8527 56.3888 17.6709 57.0062 17.3111 57.5289C16.955 58.0479 16.4399 58.4513 15.7656 58.7392C15.0952 59.0233 14.2864 59.1653 13.3395 59.1653C12.4001 59.1653 11.5819 59.0214 10.8849 58.7335C10.1918 58.4456 9.65008 58.0195 9.25993 57.4551C8.87357 56.8869 8.67092 56.1842 8.65198 55.3471H11.0327C11.0592 55.7373 11.1709 56.063 11.3679 56.3244C11.5686 56.582 11.8357 56.777 12.169 56.9096C12.5061 57.0384 12.8868 57.1028 13.3111 57.1028C13.7277 57.1028 14.0895 57.0422 14.3963 56.921C14.7069 56.7998 14.9474 56.6312 15.1179 56.4153C15.2883 56.1994 15.3736 55.9513 15.3736 55.671C15.3736 55.4096 15.2959 55.1899 15.1406 55.0119C14.9891 54.8339 14.7656 54.6824 14.4702 54.5574C14.1785 54.4324 13.8205 54.3187 13.3963 54.2164L12.1293 53.8983C11.1482 53.6596 10.3736 53.2865 9.80539 52.7789C9.2372 52.2714 8.95501 51.5877 8.9588 50.7278C8.95501 50.0233 9.14251 49.4077 9.5213 48.8812C9.90387 48.3547 10.4285 47.9437 11.0952 47.6483C11.7618 47.3528 12.5194 47.2051 13.3679 47.2051C14.2315 47.2051 14.9853 47.3528 15.6293 47.6483C16.277 47.9437 16.7808 48.3547 17.1406 48.8812C17.5005 49.4077 17.6861 50.0176 17.6974 50.7108H15.3395Z'
        fill='white'
      />
    </svg>
  )
}

export default SVGFileIcon
